import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, X } from "lucide-react";

const KEY_PREFIX = "st_wizard_banner_dismissed_";

export default function WizardBanner({ eventId, show }) {
  const dismissedKey = KEY_PREFIX + (eventId || "none");
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem(dismissedKey) === "1"; } catch { return false; }
  });
  const nav = useNavigate();
  if (!show || dismissed) return null;
  return (
    <div className="st-card p-4 mb-6 flex items-center justify-between gap-4 relative overflow-hidden" data-testid="wizard-banner"
         style={{ background: "linear-gradient(135deg, #15090b, #0e0e0e)", border: "1px solid #3a1212" }}>
      <div className="absolute right-0 bottom-0 w-56 h-56 rounded-full opacity-20"
           style={{ background: "radial-gradient(closest-side, #dc2626, transparent)" }} />
      <div className="flex items-center gap-3 z-10">
        <div className="w-10 h-10 rounded-full bg-[#dc2626] flex items-center justify-center">
          <Sparkles size={18} />
        </div>
        <div>
          <div className="font-bold">Get set up and selling in a few simple steps</div>
          <div className="text-sm text-[#bbb]">Use the setup wizard to configure your event end-to-end in minutes.</div>
        </div>
      </div>
      <div className="flex items-center gap-2 z-10">
        <button className="st-btn" onClick={() => nav("/dashboard/events/new")} data-testid="wizard-banner-start">
          Start Setup Wizard
        </button>
        <button className="text-[#7a7a7a] hover:text-white p-2"
                title="I'll set up manually" data-testid="wizard-banner-dismiss"
                onClick={() => { try { sessionStorage.setItem(dismissedKey, "1"); } catch (e) { /* ignore */ } setDismissed(true); }}>
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
